{
    "status": {
        "success": "Success",
        "refunded": "Refunded",
        "resended": "Resended",
        "renovated": "Renovated",
        "error": "Error",
        "pending": "Pending",
        "pending_short": "Pend."
    },
    "type": {
        "subscriptionBuy": "Subscription purchase",
        "subscriptionGift": "Subscription gift",
        "subscriptionRenovation": "Subscription renewal",
        "subscriptionReturn": "Subscription refund",
        "subscriptionResend": "Resend subscription",
        "subscriptionGiftRefund": "Subscription gift refund",
        "subscriptionRenewalRefund": "Subscription renewal refund",
        "subscriptionGiftResend": "Subscription gift resend",
        "subscriptionRenewalResend": "Subscription renewal resend",
        "subscriptionBuyPartialRefund": "Partial subscription refund",
        "subscriptionGiftPartialRefund": "Partial subscription gift refund",
        "ticketBuy": "Ticket purchase",
        "ticketReturn": "Ticket refund",
        "ticketResend": "Resend ticket",
        "ticketPartialRefund": "Partial ticket refund"
    },
    "articleType": {
        "REFUND_SUBSCRIPTION_ALL": "Refund of all subscriptions",
        "REFUND_TICKET_ALL": "Refund of all tickets",
        "REFUND_SUBSCRIPTION": "Subscription refund",
        "REFUND_TICKET_SUBSCRIBER": "Subscriber ticket refund",
        "REFUND_TICKET_ACCOMPANYING": "Accompanying ticket refund",
        "REFUND_TICKET_PRODUCT": "Product refund",
        "RESEND_SUBSCRIPTION": "Resend subscription",
        "RESEND_TICKET": "Resend ticket",
        "RESEND_RENEWAL": "Resend subscription renewals",
        "REFUND_RENEWAL": "Refund subscription renewals",
        "REFUND_TICKET_PARTIAL": "Partial ticket refund"
    }
}
